import Icon from '@/assets/images/covers/folder.svg'

type FolderIconProps = {
  color?: string
  size?: number
}

export default function FolderIcon({ color, size = 24 }: FolderIconProps) {
  return <Icon width={size} height={size} fill={color} />
}
